// extracted by mini-css-extract-plugin
module.exports = {"container":"UnsubscribeView_container__3UttE","nav":"UnsubscribeView_nav__33pjM","content":"UnsubscribeView_content__1gyK1","icon":"UnsubscribeView_icon___lKj_"};